/**
 * Código de país (Colombia) del flujo Bre-B. Única fuente de verdad compartida
 * entre los módulos `transaction` y `contacts` para evitar valores duplicados.
 */
export const BREB_COUNTRY_CODE = 'CO';

/**
 * Nombre de país (Colombia) del flujo Bre-B. ms-beneficiary persiste `countryName`
 * tal cual llega en el alta (sin derivarlo de `countryCode`); si el front lo omite,
 * el beneficiario queda con `countryName` nulo. Se envía para mantener el payload
 * completo y consistente con los demás flujos de alta (Stablecoin/Personal).
 */
export const BREB_COUNTRY_NAME = 'Colombia';

/**
 * Valor de `routingCodeType1` que identifica a un contacto/beneficiario como
 * Bre-B. El backend (ms-beneficiary) no filtra por rail al listar contactos
 * REMITTANCE — devuelve todos los rails del país (SWIFT/WIRE/etc.) menos P2P —
 * por lo que el frontend debe filtrar usando este discriminador tanto al
 * listar (FE filter) como al crear (debe enviarse en el payload de alta).
 */
export const BREB_ROUTING_CODE_TYPE_HANDLE = 'BREB_HANDLE';

/**
 * Valor de `routingCodeType2` de un beneficiario Bre-B: marca `routingCodeValue2`
 * como el alias legible, guardado junto al handle DICE de `routingCodeValue1`.
 */
export const BREB_ROUTING_CODE_TYPE_ALIAS = 'BREB_ALIAS';

export const BREB_RAIL_LABEL = 'Llave';

/**
 * Moneda de los beneficiarios Bre-B (Colombia). Requerida en el payload de alta:
 * ms-beneficiary la usa en el chequeo de duplicados y falla si viene `null`.
 */
export const BREB_CURRENCY_CODE = 'COP';

/**
 * `accountBranchName` de la cuenta COP que marca a una empresa bajo regulación
 * SEDPE. El backend (ms-breb) decide SEDPE por esta rama y no por el país de la
 * empresa, así que el front la usa como único criterio de regulación.
 */
export const BREB_SEDPE_BRANCH_NAME = 'B2B_GLOBAL_SEDPE';

/**
 * Tipo de transferencia del beneficiario Bre-B. Requerido por ms-beneficiary
 * (validateBeneficiaryData): rechaza con 400 BUSINESS_SERVICE si viene en blanco.
 * Mismo valor que usa el alta por banco (ContactDrawerAddStablecoin/AddBank).
 */
export const BREB_TYPE_TRANSFER = 'bank';

/**
 * Valor de `operationalCost.paymentType` que identifica que el envío se está
 * cotizando/realizando con método de pago Bre-B. Es el discriminador ÚNICO del
 * contexto de flujo Bre-B (aguas abajo), INDEPENDIENTE de la feature flag
 * `feature_breb_b2b` (que gatea la disponibilidad aguas arriba, en el Quoter).
 * Fuente única compartida por `useBrebSendContext` y `useTransactionFlow`.
 */
export const BREB_PAYMENT_TYPE = 'BREB';

/**
 * Etiquetas del menú de acciones de un contacto Bre-B. Las comparten el envío
 * individual y el multienvío: los dos ofrecen el mismo par de acciones sobre la
 * misma fila, así que el copy vive acá y no en el módulo que llegó primero.
 */
export const BREB_MENU_MODIFY_LABEL = 'Modificar';
export const BREB_MENU_DELETE_LABEL = 'Eliminar';
